import { createBrowserRouter } from "react-router";
import App from "../App";
import Error from "../pages/error";
import Dashboard from "../pages/Dashboard";
import Clientes from "../pages/Clientes";
import Ordenes from "../pages/Ordenes";
import Vehiculos from "../pages/Vehiculos";
import AddNewOrden from "../pages/Ordenes/addNewOrden";
import ViewOrden from "../pages/Ordenes/viewOrden";
import EditOrden from "../pages/Ordenes/editOrden";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,            // Layout principal
    errorElement: <Error />,   // Página de error global
    children: [
      { index: true, element: <Dashboard/> },
      { path: "/dashboard", element: <Dashboard /> },

      { path: "/clientes", element: <Clientes /> },

      { path: "/ordenes", element: <Ordenes /> },
      { path: "/ordenes/addneworder", element: <AddNewOrden /> },
      { path: "/ordenes/viewOrden", element: <ViewOrden /> },
      {path: "/ordenes/editar/:id", element: <EditOrden /> },

      { path: "/vehiculos", element: <Vehiculos /> },
    ]
    //   { path: "/acerca", element: <Acerca /> },
    //   { path: "/materias", element: <Materias /> },
    //   { path: "/biblioteca", element: <Biblioteca /> },
    //   { path: "/chismes", element: <Chismes /> },
    //   { path: "/informacion", element: <Normas /> },
    //   // { path: "/tablon_de_misiones", element: <Tablon/> },
    //   {
    //     path: "/tablon_de_misiones",
    //     element: <Tablon />,
    //     children: [
    //       { path: "misiones", element: <Misiones /> },
    //       { path: "tienda", element: <Tienda /> },
    //       { path: "perfil", element: <Perfil /> },
    //       { path: "ranking", element: <Ranking /> },
    //       { path: "admin", element: <Admin /> },
    //       { path: "mesa", element: <Mesa /> },
    //       { path: "linaje", element: <Linaje /> },
    //       { path: "mercado", element: <Mercado /> },
    //     ]
    //   }

    // 👇 Rutas individuales de materias
    // { path: "/materias/programacion-web", element: <ProgramacionWeb /> },
    // { path: "/materias/tecnicas-animacion", element: <TecnicasAnimacion /> },
    // { path: "/materias/diseno-apps", element: <DisenoApps /> },
    // { path: "/materias/mercadotecnia", element: <Mercadotecnia /> },
    // { path: "/materias/diseno-editorial", element: <DisenoEditorial /> },
    // { path: "/materias/animacion-flash", element: <AnimacionFlash /> },
    // { path: "/materias/diseno-multimedia", element: <DisenoMultimedia /> },
    // { path: "/materias/portafolio-profesional", element: <PortafolioProfesional /> },
    //   ],
  },
]);

export default router;
